import React from "react";
import SvgCurve from "./SvgCurve";
import { useRef } from "react";

export default function SvgPath({ banner }) {
  const textRef = useRef();

  return (
    <div style={{ position: "relative", paddingTop: 9 }}>
      <div
        ref={textRef}
        style={{
          position: "absolute",
          left: "0",
          top: "0",
          zIndex: 10,
          fontSize: "0.38rem",
          paddingLeft: "20px",
          color: "white",
          textAlign: "center",
          fontWeight: "500",
          textShadow:
            `1px -1px 0 ${banner.color}, 1px -1px 0 ${banner.color}, -1px 1px 0 ${banner.color}, 1px 1px 0 ${banner.color}`,
        }}
      >
        {banner?.game_info?.name}
      </div>
      <SvgCurve
        textRef={textRef}
        measureKey={banner?.id ?? banner?.game_info?.name}
        textPadding={10} // 曲线距离文字结束的安全间距
        curveWidth={35} // 弯折段宽度
        height={45} // SVG 总高度
        startY={0}
        endY={15} // 右侧结束高度
        fillColor={banner.color} // 背景填充的蓝绿色
      />
      <div
        style={{
          position: "absolute",
          left: 0,
          right: 0,
          bottom: 0,
          height: 30,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 20px",
        }}
      >
        <div style={{color:'white',fontSize:'0.24rem'}}>{banner?.game_info?.description}</div>
        <div>
          <img src={banner?.game_info?.image} alt="" height={13}/>
        </div>
      </div>
    </div>
  );
}
